[ViewState]
Mode=
Vid=
FolderType=Pictures
